import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444f5ab1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "salary-calculator" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "income-and-expenses" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headline",
  style: {"grid-row":"1"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, "1. Inkomster och utgifter"),
  /*#__PURE__*/_createElementVNode("p", null, "Fyll i dina förväntade inkomster och utgifter")
], -1))
const _hoisted_5 = { class: "net-salary-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headline",
  style: {"grid-row":"1"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, "2. Din lön!"),
  /*#__PURE__*/_createElementVNode("p", null, "Här kan du se hur din lön påverkar utdelning")
], -1))
const _hoisted_7 = { class: "info-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headline",
  style: {"grid-row":"1"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, "3. Resultat"),
  /*#__PURE__*/_createElementVNode("p", null, " Nu ser du hur bolagets ekonomi blir beroende på vad du har valt för lön etc ")
], -1))

import { computed, ref } from "vue";
import SliderPropsComponent from "@/components/SliderPropsComponent.vue";
import InfoTable from "@/components/InfoTable.vue";
import NetSalaryInfo from "@/components/NetSalaryInfo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalaryCalculator',
  setup(__props, { expose: __expose }) {

let occupancyRate = ref<number>(100);
let hourlyFee = ref(850);
let salary = ref(53100);
let taxRate = ref(31);
let vacationDays = ref(25);
let sickDays = ref(5);
let booKeepingCosts = ref(25000);
let insurance = ref(13000);
let pension = ref(80000);
let otherExpenses = ref(20000);
let wantedDividend = ref(0);
let taxRateOnDividend = ref(0.2);

const totalRevenue = computed(() => {
  let potentialPartTime = occupancyRate.value / 100;
  let oneFullTimeDay = 8;
  let sAndVDaysForPartTime = oneFullTimeDay * potentialPartTime;
  let sDays = sickDays.value * sAndVDaysForPartTime;
  let vDays = vacationDays.value * sAndVDaysForPartTime;
  const workingHoursPerYear = 2000;
  return (
    hourlyFee.value * (workingHoursPerYear * potentialPartTime - vDays - sDays)
  );
});

const totalExpenses = computed(() => {
  let expenses = [booKeepingCosts.value, insurance.value, otherExpenses.value];
  let sum = 0;
  for (let i = 0; i < expenses.length; i++) {
    sum += expenses[i];
  }
  return sum;
});

const calculateNetProfit = computed(() => {
  let expenses =
    (totalRevenue.value -
      totalExpenses.value -
      salary.value * 12 * 1.3142 -
      pension.value * 1.2624) *
      0.794 -
    wantedDividend.value;

  return Math.round(expenses);
});

const calculateDividendWithMainRule = computed(() => {
  let netProfit = calculateNetProfit.value;
  let monthlySalary = salary.value;
  let yearlySalary = salary.value * 12;

  if (monthlySalary > 37300 && yearlySalary * 12 >= 613700 && netProfit >= 0) {
    return (salary.value * 12) / 2;
  }
  return 0;
});

const calculateDividendWithSimpleRule = computed(() => {
  let netProfit = calculateNetProfit.value;
  if (netProfit <= 0) {
    return 0;
  }
  return 220671;
});

const calculateNetSalary = computed(() => {
  let tax = (100 - taxRate.value) / 100;
  let breakPoint = 53100;
  if (salary.value > breakPoint) {
    let extraTax = Math.round(salary.value - breakPoint) * 0.2; // should return 43 202 for 31% tax
    return Math.round(salary.value * tax - extraTax);
  }
  return Math.round(salary.value * tax);
});

const calculateMonthsWorthOfSalary = computed(() => {
  let salaryWithSocialTax = salary.value * 1.3142;
  return Math.round(calculateNetProfit.value / salaryWithSocialTax);
});

const calculateMaximumRangeForDividend = computed(() => {
  let simpleRuleDividend = calculateDividendWithSimpleRule.value;
  let mainRuleDividend = calculateDividendWithMainRule.value;
  if (salary.value * 12 >= simpleRuleDividend) {
    return mainRuleDividend;
  }
  return simpleRuleDividend;
  //220671
});

// We react to the event from the child component
const onUpdateHourlyFee = (event: number) => {
  hourlyFee.value = event;
};
const onUpdateSalary = (event: number) => {
  salary.value = event;
};

const onUpdateTaxRate = (event: number) => {
  taxRate.value = event;
};

const onUpdateVacationDays = (event: number) => {
  vacationDays.value = event;
};

const onUpdateSickDays = (event: number) => {
  sickDays.value = event;
};

const onUpdateBookkeepingCosts = (event: number) => {
  booKeepingCosts.value = event;
};

const onUpdateInsurance = (event: number) => {
  insurance.value = event;
};

const onUpdatePension = (event: number) => {
  pension.value = event;
};

const onUpdateOtherExpenses = (event: number) => {
  otherExpenses.value = event;
};

const onUpdateOccupancyRate = (event: number) => {
  occupancyRate.value = event;
};

const onUpdateWantedDividend = (event: number) => {
  wantedDividend.value = event;
};

__expose({ calculateMaximumRangeForDividend });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"2"},
          class: "slider-child",
          "slider-i-d": "timpris",
          "maximum-range": 1500,
          "minimum-range": 600,
          "step-for-slider": 25,
          "number-value": 850,
          "data-type": "kr",
          "information-text": "Timpris/arvode",
          title: "Ange vilket pris per timme du vill ta ut till kund, exklusive moms. För en systemutvecklare med 3-5 års erfarenhet är 850 kr en bra standard.",
          onCalculate: _cache[0] || (_cache[0] = ($event: any) => (onUpdateHourlyFee($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"3"},
          class: "slider-child",
          "information-text": "Beläggningsgrad",
          "minimum-range": 0,
          "maximum-range": 100,
          "step-for-slider": 5,
          "number-value": 100,
          "slider-i-d": "income",
          "data-type": "%",
          title: "Ange om du tänker arbeta heltid eller deltid. Observera att du kan inte fakturera din tid du lagt på möten, din ekonomi etc, utan enbart arbetade timmar.",
          onCalculate: _cache[1] || (_cache[1] = ($event: any) => (onUpdateOccupancyRate($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"4"},
          class: "slider-child",
          "information-text": "Semesterdagar /år",
          "minimum-range": 0,
          "maximum-range": 50,
          "step-for-slider": 1,
          "slider-i-d": "vacation-days",
          "number-value": 25,
          title: "Ange hur många semesterdagar du tänker ta per år. Standard är 25 dagar (5 veckor semester per år).",
          "data-type": "dagar",
          onCalculate: _cache[2] || (_cache[2] = ($event: any) => (onUpdateVacationDays($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"5"},
          class: "slider-child",
          "information-text": "Sjukdagar /år",
          "minimum-range": 0,
          "maximum-range": 15,
          "step-for-slider": 1,
          "number-value": 5,
          "slider-i-d": "sick-days",
          title: "Ange antal sjukdagar du kan komma att ha per år.",
          "data-type": "dagar",
          onCalculate: _cache[3] || (_cache[3] = ($event: any) => (onUpdateSickDays($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"6"},
          class: "slider-child",
          "information-text": "Bokföringskostnad /år",
          "minimum-range": 0,
          "maximum-range": 100000,
          "step-for-slider": 1000,
          "number-value": 25000,
          "data-type": "kr",
          "slider-i-d": "book-keeping-costs",
          title: "Ange bokföringskostnaden. Tar du hand om bokföringen själv, kan den vara så låg som 0 kr, men anlitar du ett bolag är schablonen ca 25 000 kr per år.",
          onCalculate: _cache[4] || (_cache[4] = ($event: any) => (onUpdateBookkeepingCosts($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"7"},
          class: "slider-child",
          "information-text": "Försäkringar /år",
          "minimum-range": 5000,
          "maximum-range": 25000,
          "step-for-slider": 1000,
          "number-value": 13000,
          "data-type": "kr",
          "slider-i-d": "insurance",
          title: "Ange dina kostnader för försäkringar. Här bör företagsförsäkring och sjukförsäkringskostnader ingå.",
          onCalculate: _cache[5] || (_cache[5] = ($event: any) => (onUpdateInsurance($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"8"},
          class: "slider-child",
          "information-text": "Tjänstepension /år",
          "minimum-range": 0,
          "maximum-range": 300000,
          "step-for-slider": 1000,
          "number-value": 80000,
          "data-type": "kr",
          "slider-i-d": "pension",
          title: "Ange hur mycket du vill spara till pensionen. Normalt är 4.5% av din lön.",
          onCalculate: _cache[6] || (_cache[6] = ($event: any) => (onUpdatePension($event)))
        }),
        _createVNode(SliderPropsComponent, {
          style: {"grid-row":"9"},
          class: "slider-child",
          "information-text": "Övriga kostnader /år",
          "minimum-range": 0,
          "maximum-range": 100000,
          "step-for-slider": 5000,
          "number-value": 20000,
          "data-type": "kr",
          "slider-i-d": "other-expenses",
          title: "Ange dina övriga kostnader. De kan vara licenser, resor, friskvårdsbidrag, hyror, billeasing, förbrukningsvaror och teknik med mera.",
          onCalculate: _cache[7] || (_cache[7] = ($event: any) => (onUpdateOtherExpenses($event)))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(NetSalaryInfo, {
          style: {"grid-row":"2"},
          "net-salary": calculateNetSalary.value,
          "months-worth-of-salary": calculateMonthsWorthOfSalary.value,
          "number-value": 220671,
          "net-profit": calculateNetProfit.value,
          "dividend-simplified-rule": calculateDividendWithSimpleRule.value,
          "dividend-main-rule": calculateDividendWithMainRule.value,
          "maximum-range": calculateMaximumRangeForDividend.value,
          "minimum-range": 10000,
          "step-for-slider": 500,
          "tax-rate": _unref(taxRate),
          "wanted-dividend": _unref(wantedDividend),
          "data-type": "kr",
          title: "Utdelningen i den här slidern beror på summan du vill ta ut. Du kan välja allt ifrån 0 och spara utdelningen till nästa år, eller ta ut enligt förenklingsregeln eller huvudregeln. Allt beroende på vad som är mest fördelaktigt för dig i år.",
          "information-text": "Önskad utdelning",
          onSalary: _cache[8] || (_cache[8] = ($event: any) => (onUpdateSalary($event))),
          onWantedDividend: _cache[9] || (_cache[9] = ($event: any) => (onUpdateWantedDividend($event))),
          onTaxRate: _cache[10] || (_cache[10] = ($event: any) => (onUpdateTaxRate($event)))
        }, null, 8, ["net-salary", "months-worth-of-salary", "net-profit", "dividend-simplified-rule", "dividend-main-rule", "maximum-range", "tax-rate", "wanted-dividend"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(InfoTable, {
          style: {"grid-row":"2"},
          revenue: totalRevenue.value,
          "net-profit": calculateNetProfit.value,
          "dividend-main-rule": calculateDividendWithMainRule.value,
          "dividend-simplified-rule": calculateDividendWithSimpleRule.value,
          "months-worth-of-salary": calculateMonthsWorthOfSalary.value,
          salary: _unref(salary),
          "net-salary": calculateNetSalary.value,
          "current-dividend": _unref(wantedDividend),
          "tax-on-dividend": _unref(taxRateOnDividend)
        }, null, 8, ["revenue", "net-profit", "dividend-main-rule", "dividend-simplified-rule", "months-worth-of-salary", "salary", "net-salary", "current-dividend", "tax-on-dividend"])
      ])
    ])
  ]))
}
}

})